import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gbc-modal-buttons',
    templateUrl: './modal-buttons.component.html',
    styleUrls: ['./modal-buttons.component.scss'],
    standalone: true
})
export class ModalButtonsComponent {
}
